import { useCallback, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { SharedDataContext } from "../layouts/FetchSharedData";

const useSharedData = () => {
  const { pathname } = useLocation();
  const { sharedData, setSharedData } = useContext(SharedDataContext);

  const user = useMemo(() => {
    return sharedData.user;
  }, []);

  const hasAccess = useCallback(id => {
    if (!user) {
      return false;
    }

    return user.sections.find(item => item.id === id) ? true : false;
  }, []);

  const page = useMemo(() => {
    return sharedData.pages.find(item => item.pathname === pathname);
  }, [pathname, sharedData.pages]);

  const address = useMemo(() => {
    if (!user) {
      return null;
    }
    return sharedData.user.address;
  }, []);

  const setUserIsStreamingPDF = useCallback(value => {
    setSharedData(cur => {
      cur.user.isStreamingPDF = value;

      return { ...cur };
    });
  }, []);

  return {
    pathname,
    user,
    isAuthed: user ? true : false,
    isAgent: user?.isAgent ? true : false,
    isSupervisor: user?.isSupervisor === true,
    isDistrictManager: user?.isDistrictManager === true,
    isAdmin: user?.isAdmin === true,
    canUsePreOrderCode: user?.canUsePreOrderCode ? true : false,
    hasAccess,
    page,
    address,
    setUserIsStreamingPDF,
  };
};
export default useSharedData;
